import { render } from "./TvmAutoCompleteAddress.vue?vue&type=template&id=51afd814&scoped=true"
import script from "./TvmAutoCompleteAddress.js?vue&type=script&lang=js&external"
export * from "./TvmAutoCompleteAddress.js?vue&type=script&lang=js&external"

import "./TvmAutoCompleteAddress.vue?vue&type=style&index=0&id=51afd814&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51afd814"]])

export default __exports__